import { editPostCommunity } from 'src/client/Communities'
import useMutation from 'src/hook/useMutation'
import { EditPostMutationParam } from './useEditPostModalMutation.types'

const useEditPostModalMutation = () => {
  const editPostMutation = useMutation(({ title, description, postId }: EditPostMutationParam) => {
    const payload = {
      title,
      description
    }

    return editPostCommunity(payload, postId)
  })

  return editPostMutation
}

export default useEditPostModalMutation
